export const stripHtmlTags = (htmlContent) => {
  if (!htmlContent) return ""; 

  const plainText = htmlContent.replace(/<\/?[^>]+(>|$)/g, "");

  const parser = new DOMParser();
  const decodedString = parser
    .parseFromString(plainText, "text/html")
    .documentElement.textContent;

  return decodedString;
};
